type LogLevel = 'debug' | 'info' | 'warn' | 'error' | 'silent';

const LEVELS: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
  silent: 4,
};

export class Logger {
  private level: number;

  constructor(level: LogLevel = 'warn') {
    this.level = LEVELS[level];
  }

  setLevel(level: LogLevel): void {
    this.level = LEVELS[level];
  }

  debug(...args: unknown[]): void {
    if (this.level <= LEVELS.debug) console.debug('[GGPlayer]', ...args);
  }

  info(...args: unknown[]): void {
    if (this.level <= LEVELS.info) console.info('[GGPlayer]', ...args);
  }

  warn(...args: unknown[]): void {
    if (this.level <= LEVELS.warn) console.warn('[GGPlayer]', ...args);
  }

  error(...args: unknown[]): void {
    if (this.level <= LEVELS.error) console.error('[GGPlayer]', ...args);
  }
}
